<div class="ds-overlay">
  <button
    class="ds-overlay__visibility-button"
    ftrButton
    displayType="icon"
    (click)="showFormAndGrid = !showFormAndGrid"
  >
    @if (!showFormAndGrid) {
      <svg ftrIcon="VisibilityOn" iconColor="Primary50" [iconSize]="24" class="align-top"></svg>
    }
    @if (showFormAndGrid) {
      <svg ftrIcon="VisibilityOff" iconColor="Primary50" [iconSize]="24" class="align-top"></svg>
    }
  </button>

  @if (showFormAndGrid) {
    <div class="ds-overlay__form-container">
      <ftr-select
        [items$]="pageLayouts"
        [control]="overlayForm.controls[pageLayoutsControlName]"
        defaultValue="None"
        label="Page Layout"
        class="ds-overlay__select"
      />
      <ftr-select
        [items$]="opacities"
        [control]="overlayForm.controls[opacitiesControlName]"
        defaultValue="0.3"
        label="Opacity"
        class="ds-overlay__select"
      />
    </div>
  }
  @if (showFormAndGrid) {
    <div [class]="'ds-overlay__grid ' + overlayForm.value.pageLayouts" [style.opacity]="overlayForm.value.opacities">
      <div class="ds-overlay__col"></div>
      <div class="ds-overlay__col"></div>
      <div class="ds-overlay__col"></div>
      <div class="ds-overlay__col"></div>
      <div class="ds-overlay__col"></div>
      <div class="ds-overlay__col"></div>
      <div class="ds-overlay__col"></div>
      <div class="ds-overlay__col"></div>
      <div class="ds-overlay__col"></div>
      <div class="ds-overlay__col"></div>
      <div class="ds-overlay__col"></div>
      <div class="ds-overlay__col"></div>
    </div>
  }
</div>
